import { AxiosRequestConfig } from 'axios';
import { TargetPageKey, TargetPageListType } from '../../types';
import { requester } from '../config';

export type FetchTargetPageDataParams = {
  page: TargetPageKey;
  listtype: TargetPageListType;
  searchtext: string;
  limit?: number;
};

export const fetchTargetListPageData = (
  data: FetchTargetPageDataParams,
  {
    limit = 10,
    start = 0,
    ...config
  }: { limit?: number; start?: number } & AxiosRequestConfig = {}
) =>
  requester.post(
    '/smarttarget_list',
    {
      limit,
      start,
      ...data
    },
    config
  );

export const fetchTargetPageData = (
  id: string,
  loadtype: string,
  config: AxiosRequestConfig = {}
) =>
  requester.post(
    '/smarttarget_data',
    {
      id,
      loadtype,
      limit: 25
    },
    config
  );

export const fetchTargetData = (id: string, config = {}) =>
  fetchTargetPageData(id, 'showonlyinfo', config);
